import { RootState } from "store/store";
import { connect } from "react-redux";
import { fetchCustomers } from "store/customers/customers-thunks";
import {
    setConsentStatus,
    setCustomerName,
    setCustomerDetails,
} from "store/customers/customer-details/customer-details-actions";
import {
    setActiveCustomerById,
    setActiveCustomerName,
} from "store/customers/customers-actions";
import { setIsUnsavedChangeAvailable } from "store/common/unsaved-data/unsaved-data-actions";
import CustomerDetails from "./CustomerDetails";
import {
    getCustomers,
    getCustomerNames,
} from "store/customers/customers-selectors";
import { sendEmailWithLink } from "store/customers/customer-details/customer-details-thunk";
import { setEmailSent } from "store/customers/customer-details/customer-details-actions";
import {
    setErrorResponseMessage,
    setLoaderVisibility,
} from "store/common/initialization/initialization-actions";

const mapStateToProps = (state: RootState) => {
    return {
        errorMessage: state.initializationReducer.errorResponseMessage,
        customerDetails: state.customerDetailsReducer.customerDetails,
        activeCustomer: state.customersReducer.activeCustomer,
        customers: getCustomers(state),
        customerNames: getCustomerNames(state),
    };
};
const CustomerDetailsContainer = connect(mapStateToProps, {
    setConsentStatus,
    setCustomerName,
    setCustomerDetails,
    setIsUnsavedChangeAvailable,
    fetchCustomers,
    setActiveCustomerById,
    setActiveCustomerName,
    sendEmailWithLink,
    setEmailSent,
    setLoaderVisibility,
    setErrorResponseMessage,
})(CustomerDetails);

export default CustomerDetailsContainer;
